module.exports = __webpack_public_path__ + "files/6505ef1b439882572aeaf08aeabd76ec.png";


//////////////////
// WEBPACK FOOTER
// ./images/themes/code_themes/solarized-light.png
// module id = 879
// module chunks = 60